import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getProvidersEmplpoyees } from "../slice/providersEmployeesSlice";

const ProvidersEmployees = () => {
    const dispatch = useDispatch();
    const token = localStorage.getItem("token");
    const { userData } = useSelector((state) => state.workerInfo);

    const id = userData.id;

    const { providersEmployeesData, loading, error } = useSelector(
        (state) => state.providersEmployees
    );

    useEffect(() => {
        if (!token) return;

        dispatch(getProvidersEmplpoyees({ id, token }));
    }, [id, token, dispatch]);

    console.log("providersEmployeesData", providersEmployeesData);
    return (
        <>
            <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
                <div className="ps-2 ps-lg-4">
                    <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat">
                        Employees List
                    </h4>

                    {/* LOADING */}
                    {loading && <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>}

                    {/* ERROR */}
                    {error && <p className="text-danger">{error}</p>}

                    {!loading && !error && (
                        <div className="card shadow-sm">
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered align-middle mb-0">
                                <thead>
                                    <tr>
                                        <th className="font-weight-semibold">Name</th>
                                        <th className="font-weight-semibold">Email</th>
                                        <th className="font-weight-semibold">Phone</th>
                                        <th className="font-weight-semibold">Licenced</th>
                                        <th className="font-weight-semibold">Hiring</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {providersEmployeesData.map((employee) => (
                                        <tr key={employee.id}>
                                            
                                            <td>{employee.first_name} {employee.last_name}</td>
                                            <td>{employee.email}</td>
                                            <td>{employee.phone}</td>
                                            <td>{employee.licensed || "-"}</td>
                                            <td>{employee.hiring90 || "-"}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default ProvidersEmployees;